// useInvoices.js
import { useState, useEffect, useCallback } from 'react';
import { findAllInvoices } from '~/services/hooks/invoices';

export function useInvoices(projectId = null, baseFilters = []) {
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [filters, setFilters] = useState(baseFilters);

  const fetchInvoices = useCallback(async () => {
    setLoading(true);
    try {
      const fullFilters = [
        ...filters,
        {
          field: 'lienWaiver',
          restriction: 'IS_NOT_NULL',
        },
      ];
      const data = await findAllInvoices(fullFilters);
      setInvoices(data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [projectId, filters]);

  useEffect(() => {
    if (projectId) {
      fetchInvoices();
    }
  }, [projectId, fetchInvoices]);

  return {
    invoices,
    loading,
    setFilters, // fica disponível para o componente atualizar filtros
    refresh: fetchInvoices,
  };
}
